import constants from "@/config/config.js";

export default {
  data() {
    return {
      socio: {
        nombres: null,
        apellidoMaterno: null,
        apellidoPaterno: null,
        telefono: null,
        domicilio: null,
        email: null
      },
      imagenSocio: null,
      usuario: {
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null
      }
    };
  },
  mounted() {
    this.getSocios();
  },
  methods: {
    getSocios() {
      this.socio = this.$store.getters.auth.socio;
      this.usuario = this.$store.getters.auth.usuario;
      this.imagenSocio = `${constants.apiEndPoint}${this.socio.imagenSocio}`;
    }
  }
};
